var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cursor && _vm.$vuetify.breakpoint.smAndUp)?_c('div',[_c('div',{staticClass:"cursor-animated",class:[
            _vm.progress == 0
                ? 'cursor-animated--small'
                : 'cursor-animated--large' ],attrs:{"id":"animatedcursor"}}),_c('div',{staticClass:"cursor-tooltip",class:[
            (_vm.cursor.tooltip && _vm.cursor.tooltip !== '') ||
            (_vm.cursor.link && _vm.cursor.link !== '')
                ? ''
                : 'cursor-tooltip--hidden',
            _vm.$vuetify.theme.dark
                ? 'cursor-tooltip--dark'
                : 'cursor-tooltip--white',
            _vm.cursor.link ? 'cursor-tooltip--photo' : '' ],attrs:{"id":"tooltipforcursor"}},[(_vm.cursor.link && _vm.cursor.link !== '')?[_c('v-img',{staticClass:"cursor-photo",attrs:{"width":"360","height":"203","src":_vm.cursor.link,"lazy-src":"icons/lazy.jpeg"}})]:_vm._e(),_c('div',{staticClass:"text-center",class:_vm.cursor.link && _vm.cursor.link !== '' ? 'pt-8' : ''},[_vm._v("\n            "+_vm._s(_vm.cursor.tooltip)+"\n        ")])],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }